import React, { useState } from "react";

import { SFLoadingButton, SFTypography, SFStack } from "@sf-core";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ReactComponent as EyLogo } from "./images/logo.svg";

const SigninForm = ({ onClick }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <SFStack spacing={2} alignItems="center">
      <EyLogo />
      <SFTypography variant="heroDescription">
        {t("signinScreen.welcome")}
      </SFTypography>
      <SFLoadingButton
        maxWidth={200}
        onClick={() => {
          setLoading(true);
          onClick();
        }}
        loading={loading}
      >
        {t("signinScreen.signInButton")}
      </SFLoadingButton>
    </SFStack>
  );
};

SigninForm.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default SigninForm;
